/**
 * Public legal document versions — keep in sync with TermsPage / PrivacyPage.
 * Registration must POST these literals so acceptance is auditably versioned.
 */
export const PUBLIC_TERMS_VERSION = '2026-05-v2';
export const PUBLIC_PRIVACY_VERSION = '2026-05-v1';
/**
 * Standing personal-shopper / managed-fulfillment authorization.
 * Accepted at signup (or once at checkout for legacy accounts) so checkout
 * does not re-prompt on every order.
 */
export const PUBLIC_PERSONAL_SHOPPER_AUTH_VERSION = '2026-08-v1';

export const hasValidPersonalShopperAuthorization = (auth?: {
  version?: string | null;
} | null): boolean =>
  String(auth?.version || '').trim() === PUBLIC_PERSONAL_SHOPPER_AUTH_VERSION;
